import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { User, Mail, Phone, Recycle, ChevronRight } from "lucide-react";
import api, { money } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { StatusBadge } from "@/pages/MyRicePoints";
import { Button } from "@/components/ui/button";

export default function Account() {
  const { user } = useAuth();
  const [tradeins, setTradeins] = useState([]);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    api.get("/tradein").then(({ data }) => setTradeins(data));
    api.get("/ricepoints/summary").then(({ data }) => setSummary(data));
  }, []);

  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 py-10">
      <h1 className="font-heading font-extrabold text-3xl tracking-tight">Account</h1>
      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        <div className="bg-card border border-border rounded-lg p-5">
          <div className="flex items-center gap-3">
            <span className="grid place-items-center w-12 h-12 rounded-full bg-primary/10 text-primary"><User size={22} /></span>
            <div><div className="font-heading font-bold text-lg">{user?.name}</div><div className="text-xs uppercase text-muted-foreground">{user?.role}</div></div>
          </div>
          <div className="mt-4 space-y-2 text-sm">
            <div className="flex items-center gap-2 text-muted-foreground"><Mail size={15} /> {user?.email}</div>
            <div className="flex items-center gap-2 text-muted-foreground"><Phone size={15} /> {user?.phone || "—"}</div>
          </div>
        </div>
        <Link to="/ricepoints" className="bg-secondary text-secondary-foreground rounded-lg p-5 rb-lift">
          <div className="text-sm text-secondary-foreground/70">RicePoints balance</div>
          <div className="font-heading font-extrabold text-4xl font-mono-points mt-1">{summary ? money(summary.balance) : "…"}</div>
          <div className="mt-3 text-sm flex items-center gap-1">View wallet <ChevronRight size={16} /></div>
        </Link>
      </div>

      <div className="mt-8 flex items-center justify-between">
        <h2 className="font-heading font-bold text-xl flex items-center gap-2"><Recycle className="text-primary" size={20} /> My Trade-Ins</h2>
        <Button asChild size="sm" data-testid="account-new-trade"><Link to="/trade">New Trade-In</Link></Button>
      </div>
      <div className="mt-4 space-y-3">
        {tradeins.length === 0 && <div className="text-muted-foreground text-sm py-8 text-center bg-card border border-border rounded-lg">No trade-ins yet.</div>}
        {tradeins.map((t) => (
          <Link to={`/trade/${t.trade_id}`} key={t.trade_id} className="block bg-card border border-border rounded-lg p-4 rb-lift" data-testid={`account-ti-${t.trade_id}`}>
            <div className="flex items-center justify-between gap-3">
              <div>
                <div className="font-heading font-bold font-mono-points">#{t.trade_id}</div>
                <div className="text-xs text-muted-foreground">{t.actual_weight ? `${t.actual_weight} kg actual` : `~${t.estimated_kg} kg estimated`} · pickup {t.pickup_date}</div>
              </div>
              <div className="text-right">
                <StatusBadge status={t.status} />
                <div className="text-xs text-muted-foreground mt-1 font-mono-points">{t.points_credited ? `+${money(t.points_credited)}` : `~${money(t.estimated_points)}`}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
